import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import DropdownWithTitle from '../../components/DropdownWithTitle';
import messages from '../messages';

const labels = {
  'Admissions policy ID': messages.admissionsPolicy,
  'Notification policy ID': messages.notificationPolicy,
  'Registration policy ID': messages.registrationPolicy,
  'Early decision': messages.earlyDecision,
  'Waiting list used': messages.waitingList,
  'INTLBACCALAUREATE Placement ID': messages.field_he_intlbaccalaureateplcmid,
  'Clep subject placement id': messages.field_he_clepsubjectplacement_id,
  'Ceeb advanced placement id': messages.field_he_ceebadvancedplacementid,
  'Clep credit': messages.field_he_clepcredit,
  'AP credit accepted': messages.field_he_apcredit,
};

const ImportantPolicies = ({ onChange, initialValue }) => (
  <React.Fragment>
    {Object.keys(initialValue).map((key) => initialValue[key] && (
      <DropdownWithTitle
        key={key}
        id={key}
        data-cy={`Premium-Hem-Important-Policies-${labels[initialValue[key].label].defaultMessage}`}
        title={labels[initialValue[key].label]}
        placeholder="-select an option-"
        options={initialValue[key].options}
        value={get(initialValue[key].options[initialValue[key].value], 'value')}
        onChange={(e, { value }) => {
          onChange(e, { value }, key);
        }}
      />
    ))}
  </React.Fragment>
);

ImportantPolicies.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
};

export default ImportantPolicies;
